export default __webpack_public_path__ + "static/media/more.95976c1c.svg";